import { APIFailureAction, APIRequestAction, APISuccessAction } from "@/mk2/helpers/action";
import { NormalizedResponse } from "@/mk2/helpers/api";

///////////////////////////////////////////////////////////////////
// Article load

export const ARTICLE_PHOTO_FETCH_TRIGGER = "WIKI_ARTICLE_PHOTO_FETCH_TRIGGER"; // WIKI_ prefix aby sa nemiesalo s akciami pre Article v blogoch
export interface ArticlePhotoFetchTriggerAction {
    readonly type: typeof ARTICLE_PHOTO_FETCH_TRIGGER;
    readonly articleSlug: string;
    readonly categorySlug: string;
    readonly photoId: number;
}
export const ARTICLE_PHOTO_FETCH_REQUEST = "WIKI_ARTICLE_PHOTO_FETCH_REQUEST";
export interface ArticlePhotoFetchRequestAction extends APIRequestAction {
    readonly type: typeof ARTICLE_PHOTO_FETCH_REQUEST;
    readonly articleSlug: string;
    readonly categorySlug: string;
    readonly photoId: number;
}
export interface ArticlePhotoFetchNormalizedResponse extends NormalizedResponse {
    readonly result: {
        article: number;
    };
}
export const ARTICLE_PHOTO_FETCH_SUCCESS = "WIKI_ARTICLE_PHOTO_FETCH_SUCCESS";
export interface ArticlePhotoFetchSuccessAction extends APISuccessAction<ArticlePhotoFetchNormalizedResponse> {
    readonly type: typeof ARTICLE_PHOTO_FETCH_SUCCESS;
    readonly articleSlug: string;
    readonly categorySlug: string;
    readonly photoId: number;
}
export const ARTICLE_PHOTO_FETCH_FAILURE = "WIKI_ARTICLE_PHOTO_FETCH_FAILURE";
export interface ArticlePhotoFetchFailureAction extends APIFailureAction {
    readonly type: typeof ARTICLE_PHOTO_FETCH_FAILURE;
    readonly articleSlug: string;
    readonly categorySlug: string;
    readonly photoId: number;
}

export const articlePhotoFetchTrigger = (
    articleSlug: string,
    categorySlug: string,
    photoId: number,
): ArticlePhotoFetchTriggerAction => ({
    type: ARTICLE_PHOTO_FETCH_TRIGGER,
    articleSlug,
    categorySlug,
    photoId,
});
export const articlePhotoFetchApi = {
    request: (
        articleSlug: string,
        categorySlug: string,
        photoId: number,
    ): ArticlePhotoFetchRequestAction => ({
        type: ARTICLE_PHOTO_FETCH_REQUEST,
        articleSlug,
        categorySlug,
        photoId,
    }),
    success: (
        articleSlug: string,
        categorySlug: string,
        photoId: number,
        response: ArticlePhotoFetchNormalizedResponse,
    ): ArticlePhotoFetchSuccessAction => ({
        type: ARTICLE_PHOTO_FETCH_SUCCESS,
        articleSlug,
        categorySlug,
        photoId,
        response,
    }),
    failure: (
        articleSlug: string,
        categorySlug: string,
        photoId: number,
        error: string,
    ): ArticlePhotoFetchFailureAction => ({
        type: ARTICLE_PHOTO_FETCH_FAILURE,
        articleSlug,
        categorySlug,
        photoId,
        error,
    }),
};
